import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import Grid from "@mui/material/Grid";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import {
  Card,
  CardContent,
  Chip,
  IconButton,
  Tooltip,
  Typography,
  useMediaQuery,
} from "@mui/material";
import Popover from "@mui/material/Popover";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import { useTheme } from "../../style/theme";

import { getCookie } from "../../utilities/cookies";
import PreviewAndSign from "../../components/PreviewAndSign";
import axios from "axios";
import { useMessage } from "../../components/Header";
import {
  defaultSortModel,
  documentsRenameHandller,
  generateSingingLinkFunc,
  getAllDocuments,
  movedToTrashDocuments,
} from "./Functions/document";
import ShowStatus from "../../components/Common/ShowStatus";
import DateFormate from "../../components/Common/DateFormate";
import StatusBasedSearch from "../../components/Common/StatusBasedSearch";
import SearchDocuments from "../../components/Common/SearchDocuments";
import RangeDatePicker from "../../components/Common/RangeDatePicker";
import {
  awaitingDocumentActivity,
  completedDocumentsActivity,
  draftDocumetsActivity,
  folderOptions,
  receivedDocumentsActivity,
} from "../../services/options";
import DocumentOptions from "../../components/Common/DocumentOptions";
import DocumentRenameTextField from "../../components/Common/DocumentRenameTextField";
import MovedToFolder from "../../components/MoveToFolder/MovedToFolder";
import BreadCrumbTable from "../../components/Common/BreadCrumbTable";
import { downloadFile } from "../../functions/downloadfile";
import { env } from "../../utilities/function";
import { useNavigate } from "react-router-dom";
import ShareDocumentModal from "../../components/ShareDocumentModal";
import EditAndResend from "../../components/EditAndResend";
import SendReminder from "../../components/Reminder/SendReminder";
import GenerateSingingLinkModal from "../../components/GenerateSinginLinkModal";
import { useUser } from "../../hooks/Authorize";
import CreateNewDocument from "../../components/CreateNewDocument";
import useStyles from "./Style";
import Loading from "../../components/Progress/Loading";
import { useTheme as useThemee } from "@mui/material/styles";
import { MoreVerticalIcon } from "lucide-react";

const Index = (props) => {
  const classes = useStyles();
  const [rows, setRows] = useState([]);
  const [filteredRows, setFilteredRows] = useState([]);
  const [documentType, setDocumentType] = useState("Folder");
  const [fileName, setFileName] = useState("");
  const [document, setDocument] = React.useState("");
  const [documentRowId, setDocumentRowId] = useState();
  const [documentRow, setDocumentRow] = useState();
  const [iseditableFIleName, setIsEditableFileName] = useState(false);
  const [isOpenshareModal, setIsOpenShareModal] = useState(false);
  const [isReminderModalOpen, setIsReminderModalOpen] = useState(false);
  const [isSignGenerateLinkModalOpen, setIsGenerateLinkModalOpen] =
    useState(false);
  const [isRevertModalOpen, setIsRevertModalOpen] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [pdfFile, setPdfFile] = useState(null);
  const [signDocument] = React.useState(false);
  const user = JSON.parse(localStorage.getItem("user"));
  const [breadrumbData, setBreadCrumbData] = useState([
    {
      name: "Documents",
      _id: null,
    },
  ]);
  const { showError, showSuccess } = useMessage();
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const navigate = useNavigate();
  const [selectedDateRange, setSelectedDateRange] = useState({
    startDate: new Date(new Date().setFullYear(new Date().getFullYear() - 5)),
    endDate: new Date(),
  });
  const { startDate, endDate } = selectedDateRange;
  const getRowId = (row) => row._id;
  const isEmpty = rows?.length === 0 || filteredRows?.length === 0;
  const lastFiveYearDate = new Date(
    new Date().setFullYear(new Date().getFullYear() - 5)
  );
  const theme = useTheme();

  const [isLoading, setIsLoading] = useState(true);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const onChangeHandleDatepicker = (dateStrings) => {
    if (dateStrings) {
      setSelectedDateRange({
        ...selectedDateRange,
        startDate: dateStrings[0],
        endDate: dateStrings[1],
      });
    } else {
      setSelectedDateRange({
        ...selectedDateRange,
        startDate: new Date(lastFiveYearDate),
        endDate: new Date(),
      });
    }
  };
  const onDocumentRenameChangeHandller = (e) => {
    const { value } = e.target;
    setFileName(value);
  };
  const fetchData = async (folderId) => {
    try {
      const response = await getAllDocuments(folderId, startDate, endDate);
      if (response.status === 200) {
        setRows(response.data.data);
        setFilteredRows(response.data.data);
        setIsCreateModalOpen(false);
        setIsLoading(false);
      }
    } catch (e) {
      // console.log(e);
    }
  };
  const onDoubleClickFOlderHandller = (folderId, name) => {
    const isIdExist = breadrumbData.some((item) => item._id === folderId);
    if (!isIdExist) {
      setBreadCrumbData((prevList) => [...prevList, { name, _id: folderId }]);
    }
    fetchData(folderId);
  };

  const onClickBreadCrumbHandller = (_id) => {
    fetchData(_id);
    const indexToRemove = breadrumbData.findIndex((item) => item._id === _id);
    if (indexToRemove !== -1) {
      setBreadCrumbData((prevList) => prevList.slice(0, indexToRemove + 1));
    }
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const columns = [
    {
      field: "fileName",
      headerName: "TITLE",
      flex: 4,
      minWidth: 300,
      renderCell: (params) =>
        iseditableFIleName && documentRowId === params.row._id ? (
          <DocumentRenameTextField
            value={fileName}
            onChange={onDocumentRenameChangeHandller}
            onEnterPress={documentsRename}
          />
        ) : (
          <div
            style={{ display: "flex", alignItems: "center" }}
            onDoubleClick={() =>
              params.row.status === "Folder"
                ? onDoubleClickFOlderHandller(
                    params.row._id,
                    params.row.fileName
                  )
                : {}
            }
          >
            <span>{params.row.fileName}</span>
            <ShowStatus
              backgroundColor={
                params.row.status === "Draft"
                  ? "#E6F4FC"
                  : params.row.status === "Awaiting"
                  ? "#FFF2E6"
                  : params.row.status === "Completed"
                  ? "#E3FFEA"
                  : params.row.status === "Folder"
                  ? "#295C97"
                  : params.row.status === "Received"
                  ? "#FFF2E6"
                  : "gray"
              }
              color={
                params.row.status === "Draft"
                  ? "#7D8D98"
                  : params.row.status === "Awaiting"
                  ? "#F18653"
                  : params.row.status === "Completed"
                  ? "#4BC97E"
                  : params.row.status === "Folder"
                  ? "white"
                  : params.row.status === "Received"
                  ? "#F18653"
                  : "gray"
              }
              status={params.row.status}
            />
          </div>
        ),
    },
    {
      field: "createdAt",
      headerName: "Date Created",
      flex: 1, // Takes 1 part of available space
      minWidth: 150,

      renderCell: (params) => (
        <DateFormate localFormate={params.row.createdAt} />
      ),
    },
    {
      field: "userName",
      headerName: "Created By",

      flex: 1, // Takes 1 part of available space
      minWidth: 150,
    },
    {
      field: "actions",
      headerName: "Actions",
      flex: 1, // Takes 1 part of available space
      minWidth: 150,
      align: "center",
      renderCell: () => (
        <div>
          <Tooltip title="click to see all options">
            <Button aria-describedby={id} variant="text" onClick={handleClick}>
              <MoreVerticalIcon />
            </Button>
          </Tooltip>
        </div>
      ),
    },
  ];

  const handleChange = (event) => {
    setDocument(event.target.value);
  };
  const onChangeSearchHandller = (event) => {
    const { value } = event.target;
    // Filter rows based on the search input
    const filteredData = rows.filter((row) =>
      row.fileName.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredRows(filteredData);
  };

  const fetchFile = async (fileId) => {
    const accessToken = getCookie("accessToken");
    const user = JSON.parse(localStorage.getItem("user"));
    try {
      const response = await axios.get(
        env("BACKEND_SERVER") + "/document/file/private/" + fileId,
        {
          responseType: "arraybuffer",
          headers: {
            Authorization: "Bearer " + accessToken,
          },
          withCredentials: false,
        }
      );
      if (response.status === 200) {
        const blob = new Blob([response.data], {
          type: "application/pdf",
        });
        const url = URL.createObjectURL(blob);
        setPdfFile(url);
      }
    } catch (error) {
      // console.error("Error fetching data:", error);
    }
  };
  const onClickDocumentDeleteHandller = async () => {
    const responseMessage = await movedToTrashDocuments(documentRowId);
    if (responseMessage.status === 200) {
      showSuccess(responseMessage.message);
      fetchData();
      setAnchorEl(null);
      setDocumentRowId(null);
    } else {
      showError(responseMessage.message);
    }
  };
  const documentsRename = async () => {
    const responseMessage = await documentsRenameHandller(
      documentRowId,
      fileName
    );
    if (responseMessage.status === 200) {
      showSuccess(responseMessage.message);
      fetchData();
      setAnchorEl(null);
      setDocumentRowId(null);
      setIsEditableFileName(false);
    } else {
      showError(responseMessage.message);
    }
  };

  const documentFileRenameHandlller = () => {
    setIsEditableFileName(true);
    setAnchorEl(null);
  };
  const moveToFolder = () => {
    setIsCreateModalOpen(true);
    setAnchorEl(null);
  };

  const downloadDocumentHandller = () => {
    downloadFile(pdfFile, fileName);
  };

  const sendReminderHandller = () => {
    setIsReminderModalOpen(true);
    setAnchorEl(null);
  };

  const onClickGnerateSignLinkHandller = () => {
    setIsGenerateLinkModalOpen(true);
    setAnchorEl(null);
  };

  const signHandller = async () => {
    const response = await generateSingingLinkFunc(documentRow, user.email);
    if (response.status === 200) {
      try {
        const signingLink = `${window.location.origin}/otherSigner?signerAccessToken=${response.data.signerAccessToken}`;
        window.location.href = signingLink;
      } catch (err) {
        showError("Failed to generate signing link");
      }
    }
  };

  const documentPreviewHandller = () => {
    navigate(`/documents/preview?documentId=${documentRowId}`);
  };

  const onClickActivityHandller = () => {
    navigate(
      `/documents/preview?documentId=${documentRowId}&activities=${true}`
    );
  };

  const editAndResendHandller = () => {
    setIsRevertModalOpen(true);
    setAnchorEl(null);
  };

  const shareDocumentHandller = () => {
    setIsOpenShareModal(true);
    setAnchorEl(null);
  };

  const handleCloseModal = () => {
    setIsCreateModalOpen(false);
    setIsOpenShareModal(false);
    setIsRevertModalOpen(false);
    setIsReminderModalOpen(false);
    setIsGenerateLinkModalOpen(false);
  };
   
  useEffect(() => {
    fetchData(); // Fetch data when the component mounts
  }, [selectedDateRange]);
   
  const TurnToTemplate = (documentFileId) => {
    navigate(`/templates/new?fileId=${documentFileId}`);
  };
  const themee = useThemee();
  const isMobile = useMediaQuery(themee.breakpoints.down("sm"));
  return (
    <>
      {isLoading && <Loading />}

      <Box
        sx={{
          flexGrow: 1,
          mt: 2,
          boxShadow: "none",
          border: `1px solid ${theme.mode === "dark" ? "#292929" : "#D6D6D6"}`,
          padding: { xs: 0, sm: 3 },
          borderRadius: 2,
        }}
      >
        {signDocument && (
          <Grid item xs={12} sm={12}>
            <PreviewAndSign
              pdfFile={pdfFile}
              handleCloseFunc={() => {}}
            ></PreviewAndSign>
          </Grid>
        )}
        <Typography
          variant="h6"
          sx={{ paddingTop: { xs: 3, sm: 0 }, paddingLeft: { xs: 3, sm: 0 } }}
        >
          Documents
        </Typography>
        <br />
        <Typography
          variant="body2"
          sx={{
            paddingTop: { xs: 0, sm: 0 },
            paddingLeft: { xs: 3, sm: 0 },
            paddingRight: { xs: 3, sm: 0 },
          }}
          style={{ color: "#7d8d98" }}
          className="text-wrap"
        >
          Browse all past, active and draft documents uploaded to your account.
        </Typography>
        <br />
        <Grid
          container
          justifyContent={"space-between"}
          spacing={2}
          sx={{ paddingTop: { xs: 0 }, paddingLeft: { xs: 3, sm: 0 } }}
        >
          <SearchDocuments onChangeSearchHandller={onChangeSearchHandller} />
          <StatusBasedSearch defaultStatus={`/documents`} />
          <RangeDatePicker handleDateChange={onChangeHandleDatepicker} />
        </Grid>
        {breadrumbData?.length > 1 ? (
          <BreadCrumbTable
            breadCrumbData={breadrumbData}
            onClick={onClickBreadCrumbHandller}
          />
        ) : (
          ""
        )}
        <Grid container spacing={2}>
          <Grid
            item
            xs={12}
            md={12}
            sx={{ marginTop: "25px", width: "100%", padding: { xs: 0 } }}
          >
            <div className={classes.root}>
              {isEmpty ? (
                <CreateNewDocument />
              ) : isMobile ? (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 1,
                    paddingTop: 3,
                    paddingBottom: 3,
                    paddingRight: 0.5,
                    paddingLeft: 0.5,
                  }}
                >
                  {filteredRows.map((row) => {
                    const statusColors = {
                      Draft: { bg: "#E6F4FC", text: "#7D8D98" },
                      Awaiting: { bg: "#FFF2E6", text: "#F18653" },
                      Completed: { bg: "#E3FFEA", text: "#4BC97E" },
                      Folder: { bg: "#295C97", text: "white" },
                      Received: { bg: "#FFF2E6", text: "#F18653" },
                    };
                    const colors = statusColors[row.status] || {
                      bg: "gray",
                      text: "gray",
                    };

                    return (
                      <Card
                        key={getRowId(row)}
                        sx={{
                          cursor: "pointer",
                          boxShadow: "none",
                          border: `1px solid ${
                            theme.mode === "dark" ? "#292929" : "#D6D6D6"
                          }`,
                          borderLeft: `4px solid ${colors.text}`,
                          borderRadius: 2,
                          "&:hover": { boxShadow: 6 },
                        }}
                      >
                        <CardContent>
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <Box sx={{ flex: 1 }}>
                              {iseditableFIleName &&
                              documentRowId === row._id ? (
                                <DocumentRenameTextField
                                  value={fileName}
                                  onChange={onDocumentRenameChangeHandller}
                                  onEnterPress={documentsRename}
                                />
                              ) : (
                                <Typography
                                  variant="subtitle1"
                                  fontWeight="bold"
                                >
                                  {row.fileName}
                                </Typography>
                              )}
                            </Box>
                            <IconButton
                              onClick={(e) => {
                                e.stopPropagation();
                                setDocumentRowId(row._id);
                                setDocumentRow(row);
                                setDocumentType(row.status);
                                setAnchorEl(e.currentTarget);
                              }}
                            >
                              <MoreVerticalIcon />
                            </IconButton>
                          </Box>

                          <Chip
                            label={row.status}
                            size="small"
                            sx={{
                              backgroundColor: colors.bg,
                              color: colors.text,
                              // mt: 1,
                              fontSize: "0.75rem",
                            }}
                          />

                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              mt: 1,
                            }}
                          >
                            <Box>
                              <Typography
                                variant="caption"
                                display="block"
                                color="textSecondary"
                              >
                                Created
                              </Typography>
                              <Typography variant="body2">
                                <DateFormate localFormate={row.createdAt} />
                              </Typography>
                            </Box>

                            <Box>
                              <Typography
                                variant="caption"
                                display="block"
                                color="textSecondary"
                              >
                                By
                              </Typography>
                              <Typography variant="body2">
                                {row.userName ? row.userName : "Not Completed"}
                              </Typography>
                            </Box>
                          </Box>

                          {row.status === "Folder" && (
                            <Button
                              variant="outlined"
                              size="small"
                              sx={{ mt: 1.5 }}
                              onClick={(e) => {
                                e.stopPropagation();
                                onDoubleClickFOlderHandller(
                                  row._id,
                                  row.fileName
                                );
                              }}
                            >
                              Open Folder
                            </Button>
                          )}
                        </CardContent>
                      </Card>
                    );
                  })}
                </Box>
              ) : (
                <DataGrid
                  rows={filteredRows}
                  columns={columns}
                  getRowId={getRowId}
                  sx={{ width: "100%" }}
                  initialState={{
                    pagination: { paginationModel: { pageSize: 10 } },
                  }}
                  pageSizeOptions={[10]}
                  checkboxSelection
                  sortModel={defaultSortModel}
                  disableSelectionOnClick
                  disableColumnReorder={true}
                  onRowClick={(params) => {
                    setDocumentRowId(params.row._id);
                    setDocumentRow(params.row);
                    setDocumentType(params.row.status);
                    if (params.row.fileId) {
                      setFileName(params.row.fileName);
                      fetchFile(params.row.fileId);
                    }
                  }}
                />
              )}
              <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "left",
                }}
              >
                <Stack direction="column" spacing={3} width={170}>
                  <FormControl id="buttonsID">
                    {(documentType === "Folder"
                      ? folderOptions
                      : documentType === "Completed"
                      ? completedDocumentsActivity
                      : documentType === "Awaiting"
                      ? awaitingDocumentActivity
                      : documentType === "Draft"
                      ? draftDocumetsActivity
                      : documentType === "Received"
                      ? receivedDocumentsActivity
                      : []
                    )?.map((item, index) => {
                      return (
                        <DocumentOptions
                          id={item.id}
                          name={item.name}
                          src={item.src}
                          onClick={
                            item.id === "delete"
                              ? onClickDocumentDeleteHandller
                              : item.id === "rename"
                              ? documentFileRenameHandlller
                              : item.id === "moveto"
                              ? moveToFolder
                              : item.id === "download"
                              ? downloadDocumentHandller
                              : item.id === "preview"
                              ? documentPreviewHandller
                              : item.id === "share"
                              ? shareDocumentHandller
                              : item.id === "activity"
                              ? onClickActivityHandller
                              : item.id === "editandresend"
                              ? editAndResendHandller
                              : item.id === "sendreminder"
                              ? sendReminderHandller
                              : item.id === "generatesignlink"
                              ? onClickGnerateSignLinkHandller
                              : item.id === "TurnToTemplate"
                              ? () => {
                                  TurnToTemplate(documentRowId);
                                }
                              : item.id === "sign"
                              ? signHandller
                              : () => {}
                          }
                          key={index}
                        />
                      );
                    })}
                  </FormControl>
                </Stack>
              </Popover>
            </div>
          </Grid>
        </Grid>
        <MovedToFolder
          open={isCreateModalOpen}
          handleClose={handleCloseModal}
          documentId={documentRowId}
          handleSuccess={fetchData}
        />
        <ShareDocumentModal
          open={isOpenshareModal}
          modalClose={handleCloseModal}
          documentId={documentRowId}
          handleSuccess={() => setIsOpenShareModal(false)}
        />
        <EditAndResend
          open={isRevertModalOpen}
          modalClose={handleCloseModal}
          documentRowId={documentRowId}
          handleSuccess={fetchData}
          fileId={documentRow?.fileId}
        />
        <SendReminder
          modalClose={handleCloseModal}
          open={isReminderModalOpen}
          documentId={documentRowId}
        />
        <GenerateSingingLinkModal
          documentId={documentRowId}
          open={isSignGenerateLinkModalOpen}
          modalClose={handleCloseModal}
        />
      </Box>
      <div className="im-divider"></div>
    </>
  );
};

export default Index;
